import React from 'react';
import { Book, Clock, Brain } from 'lucide-react';
import { MenuOptions } from '../../../types/Menu';
import { OptionGroup } from './OptionGroup';
import { AdditionalOptions } from './AdditionalOptions';
import { PriceSelector } from './PriceSelector';

interface MenuOptionsPanelProps {
  options: MenuOptions;
  onToggleOption: (option: keyof MenuOptions) => void;
  onUpdateOption: (option: keyof MenuOptions, value: any) => void;
  useAI: boolean;
}

export const MenuOptionsPanel: React.FC<MenuOptionsPanelProps> = ({
  options,
  onToggleOption,
  onUpdateOption,
  useAI
}) => {
  return (
    <div className="bg-gradient-to-br from-orange-50 to-amber-50 rounded-lg p-6 shadow-sm">
      <h3 className="font-semibold mb-6 flex items-center gap-2 text-lg">
        <Book className="text-orange-500" size={24} />
        Personaliza tu menú
      </h3>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
        <div className="space-y-6">
          <PriceSelector
            value={options.maxPricePerDish}
            onChange={(value) => onUpdateOption('maxPricePerDish', value)}
          />

          <OptionGroup
            title="Número de platos"
            options={[
              { value: 1, label: '1 plato - 1 persona' },
              { value: 2, label: '2 platos - 2-3 personas' },
              { value: 3, label: '3 platos - 4+ personas' }
            ]}
            selectedValue={options.courseCount}
            onChange={(value) => onUpdateOption('courseCount', value)}
          />

          {useAI && (
            <>
              <OptionGroup
                title="Dificultad"
                icon={<Brain className="text-orange-500" size={20} />}
                options={[
                  { value: 'easy', label: 'Fácil' },
                  { value: 'medium', label: 'Media' },
                  { value: 'hard', label: 'Difícil' }
                ]}
                selectedValue={options.difficulty}
                onChange={(value) => onUpdateOption('difficulty', value)}
              />

              <OptionGroup
                title="Tiempo de preparación"
                icon={<Clock className="text-orange-500" size={20} />}
                options={[
                  { value: 'quick', label: '15-30 min' },
                  { value: 'medium', label: '30-60 min' },
                  { value: 'elaborate', label: '+60 min' }
                ]}
                selectedValue={options.cookingTime}
                onChange={(value) => onUpdateOption('cookingTime', value)}
              />
            </>
          )}
        </div>

        {useAI && (
          <AdditionalOptions
            options={options}
            onToggleOption={onToggleOption}
          />
        )}
      </div>
    </div>
  );
};